import React from 'react';
import { Link } from 'react-router-dom';

function SitemapPage() {
  return (
    <section className="min-h-[60vh] bg-[#f7fafd] py-20 px-4 md:px-0 flex flex-col items-center">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8 animate-fadeIn">
        <h1 className="text-3xl font-bold text-blue-900 mb-6 text-center">Plan du site</h1>
        <ul className="space-y-4 text-blue-800 text-lg">
          <li><Link to="/" className="underline hover:text-blue-500">Accueil</Link></li>
          <li><button className="underline hover:text-blue-500">Fonctionnalités</button></li>
          <li><Link to="/pricing" className="underline hover:text-blue-500">Tarifs</Link></li>
          <li><Link to="/contact" className="underline hover:text-blue-500">Contact</Link></li>
          <li><button type="button" className="underline hover:text-blue-500 bg-transparent border-none p-0 m-0 cursor-pointer">CGU</button></li>
          <li><button type="button" className="underline hover:text-blue-500 bg-transparent border-none p-0 m-0 cursor-pointer">CGV</button></li>
          <li><button type="button" className="underline hover:text-blue-500 bg-transparent border-none p-0 m-0 cursor-pointer">Politique de confidentialité</button></li>
        </ul>
        <div className="mt-8 text-xs text-blue-400 text-center">Dernière mise à jour : juillet 2025</div>
      </div>
    </section>
  );
}

export default SitemapPage; 